import { Control, Controller } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import useConsiderationCalculations, {
  ConsiderationTotalType,
} from '../../hooks/useConsiderationCalculations';
import FormField from 'further-ui/components/FormField';
import { Row } from 'further-ui/components/Layout';
import NumberInput from 'further-ui/components/NumberInput';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Box, InputAdornment, Typography, styled } from '@mui/material';

const FlexCell = styled(Box)({ flex: 1 });

type Props = {
  control: Control<rules.CreateRealisationFormValues>;
  index: number;
  currencyCode: CurrencyCode;
  disabled: boolean;
};

const ManualWithholdingTaxConsiderationRow: React.FC<Props> = ({
  control,
  index,
  currencyCode,
  disabled,
}) => {
  const { setFieldFocus } = useConsiderationCalculations();

  return (
    <FormField
      label="Withholding tax payable"
      labelSize="sm"
      tooltip="This is the total withholding tax payable by the fund and its limited partners as part of the realisation. All consideration lines above should exclude withholding tax. If withholding tax is the buyer's responsibility or is paid on the fund's behalf (and not recorded as a fund-level expense), leave this field empty."
      layout="horizontal"
      breakpoint="md"
    >
      <Row spacing="sm">
        <FlexCell>
          <Controller
            name={`holdingClassRealisation.${index}.cashConsiderationAmounts.withholdingTaxPayable`}
            control={control}
            render={({
              field: { ref, onChange, ...rest },
              fieldState: { error },
            }) => (
              <NumberInput
                {...rest}
                currencyStartAdornment
                placeholder="Enter amount"
                disabled={disabled}
                currency={currencyCode}
                decimals={2}
                min={0}
                fullWidth
                onChange={(value) => {
                  onChange(value);
                }}
                onFocus={() => {
                  setFieldFocus(ConsiderationTotalType.WithholdingTax);
                }}
                error={!!error}
                helperText={error?.message}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography variant="body2">Total</Typography>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            )}
          />
        </FlexCell>
        <FlexCell />
      </Row>
    </FormField>
  );
};

export default ManualWithholdingTaxConsiderationRow;
